export default __webpack_public_path__ + "static/media/drs.df4365aa.png";